import classNames from 'classnames';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';
import { FilterType } from '../../hooks/types';

const BrandsFilter = ({ className }: { className?: string }) => {
  const { filters, selectedFilters, toggleFilter, fixedFilters, type } =
    useCollectionPageContext();

  if (type === 'MS_CATALOG_DEALS') {
    return null;
  }

  const brands = filters?.brands ?? [];
  const selectedBrands = selectedFilters?.brands;

  if (brands.length <= 1) {
    return null;
  }

  return (
    <div className={classNames('overflow-hidden', className)}>
      <div
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="hide-scrollbar flex gap-x-1 overflow-x-auto"
      >
        {brands.map((b) => {
          // Fixed Filters should always appear selected and be disabled
          const isFixedFilter =
            fixedFilters.brandIds?.includes(b.id) ||
            fixedFilters.brands?.includes(b.name);
          // Selected Brands includes the fixed brand filter
          const isBrandSelected =
            selectedBrands?.some((s) => s.id === b.id) || isFixedFilter;

          return (
            <button
              disabled={isFixedFilter}
              key={b.id}
              onClick={() => toggleFilter(FilterType.BRAND, b.id, b.name)}
              className={classNames(
                'h-10 shrink-0 whitespace-nowrap rounded border px-3 hover:border-gray-700 hover:underline hover:underline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                { 'border-gray-700 font-bold text-gray-700': isBrandSelected },
              )}
            >
              {b.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BrandsFilter;
